import React from "react";
import { OrderDetailsData } from "../../../../../../../../services/Api/Public/types";
import { OrderNumber } from "../OrderDetails/components/OrderNumber";
import OrderInfoDelivery from "./OrderInfoDelivery";
import OrderInfoPlace from "./OrderInfoPlace";

interface Props {
	details: OrderDetailsData;
}

const OrderInfoSection = ({ details }: Props) => {
	return (
		<section data-testid="e-order-order-info-section" className="order-info-section">
			<OrderNumber orderNumber={details.number} transactionDate={details.closed_at} />
			<OrderInfoDelivery />
			<OrderInfoPlace />
		</section>
	);
};

export default OrderInfoSection;
